// extracted by mini-css-extract-plugin
export default {"group":"ToggleGroup_group__LC8ld","size-sm":"ToggleGroup_size-sm__frFrW","size-md":"ToggleGroup_size-md__HarA2","size-lg":"ToggleGroup_size-lg__3cmZE"};